import { Query } from '../../_base/actionBus/Query';
import { UnitPayment } from '../../models/payments/UnitPayment';

export class GetUnitPayments extends Query<UnitPayment[]> {}
